import { render, staticRenderFns } from "./IssueRiskScore.vue?vue&type=template&id=3561fb9a&scoped=true"
import script from "./IssueRiskScore.vue?vue&type=script&lang=js"
export * from "./IssueRiskScore.vue?vue&type=script&lang=js"
import style0 from "./IssueRiskScore.vue?vue&type=style&index=0&id=3561fb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561fb9a",
  null
  
)

export default component.exports